import { createTheme as createMuiTheme } from "@mui/material/styles";
import { breakpoint } from "../miStandard/miStandard";
import { MiTHEME } from "../miTheme/miTheme";

export const createTheme = () => {
  return createMuiTheme({
    ...MiTHEME,
    spacing: 4,
    breakpoints: {
      values: breakpoint,
    },
    palette: {
      ...MiTHEME.palette,
      main: {
        primary: MiTHEME.palette.primary.main,
        secondary: MiTHEME.palette.primary.main,
        accent: MiTHEME.palette.grey.main,
        light: MiTHEME.palette.blue.light,
      },
    },
  });
};
